export async function nextPage() {
    this.page.number += 1;
    await this.getSubscriptions();
}
